import { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?',
    props: true,
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        alias: ['info/:invoiceId?'],
        props: true,
        component: () => import('pages/home-page/IndexPage.vue'),
      },
      {
        path: '/terms',
        component: () => import('pages/agreement-pages/TermsOfUsePage.vue'),
      },
      {
        path: '/policy',
        component: () => import('pages/agreement-pages/PrivacyPolicyPage.vue'),
      },
      {
        path: '/QmkacU7TYYYEdY8Av73h9aVkkgGLXq',
        component: () => import('pages/info-rew-page/InfoRewPage.vue'),
        meta: {
          hideFooter: true,
          hideHeader: true,
        },
      },
      {
        path: '/Yht4Dv8lPy54Sxj9jhFbvGdfTh5',
        component: () => import('pages/promo-codes-page/PromoCodesPage.vue'),
        meta: {
          hideFooter: true,
          hideHeader: true,
        },
      },
      {
        path: '/policy',
        component: () => import('pages/agreement-pages/PrivacyPolicyPage.vue'),
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
